import { createAction } from 'redux-actions'

export const types = {
    GET_API_POLLING_TIME_INTERVAL: 'api/GET_API_POLLING_TIME_INTERVAL',
    GET_SETTINGS: 'api/GET_SETTINGS',
    API_CALL_FAILURE: 'api/API_CALL_FAILURE',
    API_CALL_SUCCESS: 'api/API_CALL_SUCCESS',
    GET_MAP_DATA: 'api/GET_MAP_DATA',
    GET_LEADERBOARD_DATA: 'api/GET_LEADERBOARD_DATA',
    GET_DONOR_ROLL_DATA: 'api/GET_DONOR_ROLL_DATA',
    GET_AFFILIATION_DATA: 'api/GET_AFFILIATION_DATA',
    GET_CAMPAIGN_DASHBOARD_DATA: 'api/GET_CAMPAIGN_DASHBOARD_DATA',
    GET_AMBASSADOR_DATA: 'api/GET_AMBASSADOR_DATA',
    GET_CHALLENGE_DATA: 'api/GET_CHALLENGE_DATA',
    START_GET_CHALLENGE_DATA: 'api/START_GET_CHALLENGE_DATA',
    POST_AFTER_SOCIAL_SHARE: 'api/POST_AFTER_SOCIAL_SHARE',
    START_AFTER_SOCIAL_SHARE: 'api/START_AFTER_SOCIAL_SHARE',
    GET_AMBASSADOR_PROFILE: 'api/GET_AMBASSADOR_PROFILE',
    START_GET_AMBASSADOR_PROFILE: 'api/START_GET_AMBASSADOR_PROFILE',
    START_VIEWCHALLENGE_DATA: 'api/START_VIEWCHALLENGE_DATA',
    GET_VIEWCHALLENGE_DATA: 'api/GET_VIEWCHALLENGE_DATA01',
    START_GET_VIEW_AMBASSADOR_PROFILE: 'api/START_GET_VIEW_AMBASSADOR_PROFILE',
    GET_VIEW_AMBASSADOR_PROFILE: 'api/GET_VIEW_AMBASSADOR_PROFILE',
    API_START_CALLED: 'api/API_START_CALLED',
}

export const actions = {
    getApiPollingTimeInterval: createAction(types.GET_API_POLLING_TIME_INTERVAL),
    apiCallFailure: createAction<string>(types.API_CALL_FAILURE),
    apiCallSuccess: createAction(types.API_CALL_SUCCESS),
    getSettings: createAction<number>(types.GET_SETTINGS),
    getMapData: createAction<DataApiSettings>(types.GET_MAP_DATA),
    getLeaderboardData: createAction(types.GET_LEADERBOARD_DATA),
    getDonorRollData: createAction(types.GET_DONOR_ROLL_DATA),
    getAffiliationData: createAction(types.GET_AFFILIATION_DATA),
    getCampaignDashboardData: createAction(types.GET_CAMPAIGN_DASHBOARD_DATA),
    getAmbassadorData: createAction(types.GET_AMBASSADOR_DATA),
    getChallengeData: createAction(types.GET_CHALLENGE_DATA),
    startGetChallengeData: createAction(types.START_GET_CHALLENGE_DATA),
    postAfterSocialShare: createAction(types.POST_AFTER_SOCIAL_SHARE),
    startAfterSocialShare: createAction(types.START_AFTER_SOCIAL_SHARE),
    getAmbassadorProfile: createAction(types.GET_AMBASSADOR_PROFILE),
    startAmbassadorProfile: createAction(types.START_GET_AMBASSADOR_PROFILE),
    startViewChallengeData: createAction(types.START_VIEWCHALLENGE_DATA),
    getViewchallengeData: createAction(types.GET_VIEWCHALLENGE_DATA),
    startViewAmbassadorProfile: createAction(types.START_GET_VIEW_AMBASSADOR_PROFILE),
    getViewAmbassadorProfile: createAction(types.GET_VIEW_AMBASSADOR_PROFILE),
    apiCallStarted: createAction(types.API_START_CALLED),

}